// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".to-top-btn[data-v-684596cb] {\n  height: 49px;\n  width: 49px;\n  position: fixed;\n  bottom: 54px;\n  right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
